import { appliedAdapter } from './applied/applied.adapter';
import { gigaAdapter } from './giga/giga.adapter';
import type { ChatbotVendor, ChatbotVendorAdapter } from './types';

/** Defaults to Applied Labs (the live vendor), so an absent/unknown vendor is the safe fallback. */
export const createChatbotVendorAdapter = (
  vendor: ChatbotVendor = 'applied',
): ChatbotVendorAdapter => {
  switch (vendor) {
    case 'giga':
      return gigaAdapter;
    case 'applied':
    default:
      return appliedAdapter;
  }
};
